module.exports = __webpack_public_path__ + "img/2_165.218d1af4.png";